import { useQuery } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { DICOM_ENDPOINT } from "@src/config/baseUrls";
import { queryKeys } from "@src/config/queryKeys";

export interface DicomHeader {
  tag: string;
  vr: string;
  value: string;
  vm: string;
  length: string;
  description: string;
}

const useDicomHeaders = (s3Url: string) => {
  const axios = useAxios();
  return useQuery<DicomHeader[]>(
    [queryKeys.DICOM_HEADERS, s3Url],
    async () => {
      const { data } = await axios.get(
        `${DICOM_ENDPOINT}/headers/${encodeURIComponent(s3Url)}`,
      );
      return data;
    },
    { refetchOnMount: false },
  );
};
export default useDicomHeaders;
